import firebase from 'firebase/app';
import moment from 'moment';
import { Position,  Intent, Toaster } from "@blueprintjs/core";

const AppToaster = Toaster.create({
    className: "liked message",
    position: Position.TOP,
});

const showLikedToast = () => {
    AppToaster.show({ message: "Wooo! This message is saved to your profile page", intent: Intent.DANGER, timeout: 2000});
}

export const customApprove = async(fbProfile, contentGen, intVal, vProp, docId, messageType, setBtnClicked, name, auth, onboarded) =>{

    var messagesRef = firebase
                    .firestore()
                    .collection('organizations')
                    .doc(fbProfile.company)
                    .collection('prospects')
                    .doc(docId)

    if(onboarded?.[0]?.onboarded === 'no'){
        console.log('hello')
    } else {
        messagesRef
        .update({
            ContentLiked: firebase.firestore.FieldValue.arrayUnion({
                TimeApprovedAt: moment(new Date()).format('L').toString().replace(/\//g, ""),
                ProspectName: name,
                ProspectContent: contentGen,
                InterestUsed: intVal,
                ValueProp: vProp,
                ModelUsed: messageType ? messageType : ''
            })
        })
    }

    firebase
        .firestore()
        .collection('likedContent')
        .doc()
        .set({
            ProspectName: name,
            AuthorFirstName: fbProfile.firstName,
            AuthorLastName: fbProfile.lastName,
            AuthorID: auth.uid,
            CreatedBy: fbProfile.email,
            Company: fbProfile.company,
            InterestUsed: intVal,
            ValueProp: vProp,
            ModelUsed: messageType ? messageType : '',
            ProspectContent: contentGen,
            TimeApprovedAt: moment(new Date()).format('L').toString().replace(/\//g, ""),
            CreatedAt: new Date(),
        })

    showLikedToast()
    setBtnClicked(true)
} 